module.exports = __webpack_public_path__ + "images/emoji/clock4.c7afaf679f16c611f3d7.png";